import React from 'react'
import { Document, Page, Text, View, Font } from "@react-pdf/renderer";
import sitlogo from '../../assets/images/sitlogo.png';
import { IMG_URL } from '../BaseUrl';
import { formatDate } from '../../Utils/dateFormat';

const Footer = () => (
  <View
    fixed
    style={{
      position: 'absolute',
      bottom: 20,

      right: 30,
      width: '100%',
      textAlign: 'center',
      fontSize: 8,
      color: 'black',
      justifyContent: "flex-end",
      alignItems: "flex-end"
    }}
  >
    <Text render={({ pageNumber }) => `${pageNumber}`} />
  </View>
);

const FeesRecordNew = ({ data }) => {

  const headerdata = data.headerdata[0];
  const Fees = data.headerdata[0].Fees_Full_Payment;
  const feesdata = data.feesdata;




  Font.register({
    family: 'Poppins',
    fonts: [
      {
        src: '/fonts/Poppins-Regular.ttf',
        fontWeight: 'normal',
      },
      {
        src: '/fonts/Poppins-SemiBold.ttf',
        fontWeight: 600,
      },
      {
        src: '/fonts/Poppins-Bold.ttf',
        fontWeight: 'bold',
      },

    ],
  });

  const Header = () => (
    <View fixed>
      {/* Header and Course Info */}
      <View style={{ textAlign: "left", width: '100%', height: "20px" }}>
        <Text style={{ fontSize: 8, fontWeight: 600, fontFamily: 'Poppins' }}>
          Suvidya Institute Of Techonology Pvt. Ltd
        </Text>
      </View>
      <View style={{ textAlign: "center", width: '100%', height: "20px", border: "1px solid black", justifyContent: "center" }}>
        <Text style={{ fontSize: 10, fontWeight: 600, fontFamily: 'Poppins' }}>
          FEES RECORD
        </Text>
      </View>
      <View style={{
        width: '100%',
        flexDirection: "column",
        top: 2,

        borderTop: '1.5px solid black',
        borderBottom: '1px solid black'
      }}>
        <View style={{
          flexDirection: 'row', borderBottom: '1px solid black', borderLeft: '1.5px solid black',
          borderRight: '1.5px solid black', width: '100%', height: "18px"
        }}>
          <View style={{ width: '9%', paddingLeft: 6, alignItems: 'center', justifyContent: "center" }}>
            <Text style={{ fontSize: 8.5, fontWeight: 600, fontFamily: 'Poppins' }}>Course :</Text>
          </View>
          <View style={{ width: '38%', alignItems: "flex-start", paddingLeft: 2, justifyContent: "center" }}>
            <Text style={{ fontSize: 8.5, fontWeight: 600, fontFamily: 'Poppins' }}>{headerdata.Course_Name}</Text>
          </View>
          <View style={{ width: '10%', alignItems: 'flex-start', justifyContent: "center" }}>
            <Text style={{ fontSize: 8.5, fontWeight: 600, fontFamily: 'Poppins' }}>Batch No. :</Text>
          </View>
          <View style={{ width: '10%', alignItems: 'center', justifyContent: "center" }}>
            <Text style={{ fontSize: 8.5, fontWeight: 600, fontFamily: 'Poppins' }}>{headerdata.Batch_code}</Text>
          </View>
          <View style={{ width: '6%', paddingLeft: 2, alignItems: 'flex-start', justifyContent: "center" }}>
            <Text style={{ fontSize: 8.5, fontWeight: 600, fontFamily: 'Poppins' }}>From :</Text>
          </View>
          <View style={{ width: '12%', alignItems: 'center', justifyContent: "center" }}>
            <Text style={{ fontSize: 8.5, fontWeight: 600, fontFamily: 'Poppins' }}>{headerdata.SDate}</Text>
          </View>
          <View style={{ width: '4%', paddingLeft: 2, alignItems: 'flex-start', justifyContent: "center" }}>
            <Text style={{ fontSize: 8.5, fontWeight: 600, fontFamily: 'Poppins' }}>To :</Text>
          </View>
          <View style={{ width: '12%', alignItems: 'center', justifyContent: "center" }}>
            <Text style={{ fontSize: 8.5, fontWeight: 600, fontFamily: 'Poppins' }}>{headerdata.EDate}</Text>
          </View>
        </View>
        <View style={{
          flexDirection: 'row', width: '100%', height: "18px", borderLeft: '1.5px solid black',
          borderRight: '1.5px solid black',
        }}>
          <View style={{ width: '78%', paddingLeft: 6, alignItems: 'center', justifyContent: "center" }}>
          </View>
          <View style={{ width: '10%', paddingLeft: 2, alignItems: 'flex-start', justifyContent: "center" }}>
            <Text style={{ fontSize: 8.5, fontWeight: 600, fontFamily: 'Poppins' }}>Fees (Rs.)</Text>
          </View>
          <View style={{ width: '12%', alignItems: 'flex-end', justifyContent: "center" }}>
            <Text style={{ fontSize: 8.5, fontWeight: 600, fontFamily: 'Poppins' }}>{headerdata.Fees_Full_Payment}</Text>
          </View>
        </View>
        <View style={{
          flexDirection: 'row', width: '100%', height: "18px", borderLeft: '1.5px solid black',
          borderRight: '1.5px solid black',
        }}>
        </View>
      </View>
    </View>
  );

  return (
    <Document>
      <Page size="A4" style={{ padding: 30, fontSize: 10 }}>
        <Header />
        <View style={{
          width: '100%',
          flexDirection: "column",
          top: 2,
          borderTop: '1.5px solid black',
          borderBottom: '1px solid black'
        }}>
          {/* Name and Transaction Table */}

          {feesdata.map((item, idx) => {

            const debitTotal = item.itsdata
              .filter(txn => txn.TypeR === 'D')
              .reduce((sum, txn) => sum + parseFloat(txn.Amount), 0);

            const creditTotal = item.itsdata
              .filter(txn => txn.TypeR === 'C')
              .reduce((sum, txn) => sum + parseFloat(txn.Amount), 0);

            const balance = Fees - creditTotal;

            return (
              <View
                key={idx}
                style={{ flexDirection: 'column', width: '100%', borderLeft: '1.5px solid black', borderRight: '1.5px solid black', }}
                break={item.itsdata?.length <= 21 && idx === 4}
              >

                <View style={{ flexDirection: 'row', borderBottom: '1px solid black', width: '100%', height: "18px" }}>
                  <View style={{ width: '9%', paddingLeft: 6, alignItems: 'center', justifyContent: "center" }}>
                    <Text style={{ fontSize: 8.5, fontWeight: 600, fontFamily: 'Poppins' }}>Name : </Text>
                  </View>
                  <View style={{ width: '66%', alignItems: "flex-start", paddingLeft: 20, justifyContent: "center" }}>
                    <Text style={{ fontSize: 8.5, fontFamily: 'Poppins' }}>{item.Student_Name}</Text>
                  </View>
                  <View style={{ width: '4%', paddingLeft: 2, alignItems: 'flex-start', justifyContent: "center" }}>
                    <Text style={{ fontSize: 8.5, fontWeight: 600, fontFamily: 'Poppins' }}>ID :</Text>
                  </View>
                  <View style={{ width: '21%', alignItems: 'flex-start', paddingLeft: 2, justifyContent: "center" }}>
                    <Text style={{ fontSize: 8.5, fontFamily: 'Poppins' }}>{item.Student_Code}</Text>
                  </View>
                </View>
                <View style={{ flexDirection: 'row', borderBottom: '1px solid black', width: '100%', height: "22px" }}>
                  <View style={{ width: '12%', alignItems: 'center', justifyContent: "center", borderRight: '1px solid black' }}>
                    <Text style={{ fontSize: 8.5, fontWeight: 600, fontFamily: 'Poppins' }}>Date </Text>
                  </View>
                  <View style={{ width: '41%', alignItems: "center", paddingLeft: 20, justifyContent: "center", borderRight: '1px solid black' }}>
                    <Text style={{ fontSize: 8.5, fontFamily: 'Poppins', fontWeight: 600, }}>Particular</Text>
                  </View>
                  <View style={{ width: '11%', alignItems: 'center', justifyContent: "center", borderRight: '1px solid black' }}>
                    <Text style={{ fontSize: 8.5, fontWeight: 600, fontFamily: 'Poppins' }}>Type</Text>
                  </View>
                  <View style={{ width: '14%', alignItems: 'center', justifyContent: "center", borderRight: '1px solid black' }}>
                    <Text style={{ fontSize: 8.5, fontFamily: 'Poppins', fontWeight: 600, }}>Receipt No.</Text>
                  </View>
                  <View style={{ width: '11%', alignItems: 'center', justifyContent: "center", borderRight: '1px solid black' }}>
                    <Text style={{ fontSize: 8.5, fontFamily: 'Poppins', fontWeight: 600, }}>Debit</Text>
                  </View>
                  <View style={{ width: '11%', alignItems: 'center', justifyContent: "center" }}>
                    <Text style={{ fontSize: 8.5, fontFamily: 'Poppins', fontWeight: 600, }}>Credit</Text>
                  </View>
                </View>
                {/* Dynamic Transactions */}
                {item.itsdata.map((txn, index) => (
                  <View
                    key={index}
                    style={{ flexDirection: 'row', borderBottom: '1px solid black', width: '100%', height: "24px" }}
                    break={item.itsdata?.length > 21 && index === 20}
                  >
                    <View style={{ width: '12%', alignItems: 'center', justifyContent: "center", borderRight: '1px solid black' }}>
                      <Text style={{ fontSize: 8.5, fontFamily: 'Poppins' }}>{txn.RDate}</Text>
                    </View>
                    <View style={{ width: '41%', alignItems: "flex-start", paddingLeft: 10, justifyContent: "center", borderRight: '1px solid black' }}>
                      <Text style={{ fontSize: 8.5, fontFamily: 'Poppins' }}>{txn.Cheque_No}</Text>
                    </View>
                    <View style={{ width: '11%', alignItems: 'flex-start', paddingLeft: 5, justifyContent: "center", borderRight: '1px solid black' }}>
                      <Text style={{ fontSize: 8.5, fontFamily: 'Poppins' }}>{txn.Payment_Type}</Text>
                    </View>
                    <View style={{ width: '14%', alignItems: 'flex-start', paddingLeft: 5, justifyContent: "center", borderRight: '1px solid black' }}>
                      <Text style={{ fontSize: 8.5, fontFamily: 'Poppins' }}>{txn.Fees_Code}</Text>
                    </View>
                    <View style={{ width: '11%', alignItems: 'flex-end', paddingRight: 5, justifyContent: "center", borderRight: '1px solid black' }}>
                      <Text style={{ fontSize: 8.5, fontFamily: 'Poppins' }}>{txn.TypeR == 'D' ? txn.Amount : ''}</Text>
                    </View>
                    <View style={{ width: '11%', alignItems: 'flex-end', paddingRight: 5, justifyContent: "center" }}>
                      <Text style={{ fontSize: 8.5, fontFamily: 'Poppins' }}>{txn.TypeR == 'C' ? txn.Amount : ''}</Text>
                    </View>
                  </View>
                ))}
                {/* Totals Row */}
                <View style={{ flexDirection: 'row', borderBottom: '1px solid black', width: '100%', height: "17px" }}>
                  <View style={{ width: '41%', alignItems: 'flex-end', justifyContent: "center", }}>
                    <Text style={{ fontSize: 8.5, fontWeight: 600, fontFamily: 'Poppins' }}>Debit :</Text>
                  </View>
                  <View style={{ width: '12%', alignItems: "center", paddingLeft: 20, justifyContent: "center", }}>
                    <Text style={{ fontSize: 8.5, fontFamily: 'Poppins', fontWeight: 600, }}>{Fees}</Text>
                  </View>
                  <View style={{ width: '11%', alignItems: 'center', justifyContent: "center", }}>
                    <Text style={{ fontSize: 8.5, fontWeight: 600, fontFamily: 'Poppins' }}>Credit :</Text>
                  </View>
                  <View style={{ width: '14%', alignItems: 'center', justifyContent: "center" }}>
                    <Text style={{ fontSize: 8.5, fontFamily: 'Poppins', fontWeight: 600, }}>{creditTotal}</Text>
                  </View>
                  <View style={{ width: '11%', alignItems: 'center', justifyContent: "center" }}>
                    <Text style={{ fontSize: 8.5, fontFamily: 'Poppins', fontWeight: 600, }}>Balance :</Text>
                  </View>
                  <View style={{ width: '11%', alignItems: 'flex-start', justifyContent: "center" }}>
                    <Text style={{ fontSize: 8.5, fontFamily: 'Poppins', fontWeight: 600, }}>{balance}</Text>
                  </View>
                </View>
              </View>
            )
          })}
        </View>
        <Footer />
      </Page>
    </Document>
  )
}

export default FeesRecordNew